 (function (w, d) {
        var id = 'podscribe-capture',
        n = 'script';
        var e = d.createElement(n);
        e.id = id;
        e.async = true;
        e.src = 'https://d34r8q7sht0t9k.cloudfront.net/tag.js';
        var s = d.getElementsByTagName(n)[0];
        s.parentNode.insertBefore(e, s);
        e.addEventListener('load', function() {
          w.podscribe('init', {
            user_id: 'e57161e7-790c-4707-80c0-40a21e8f161e',
            advertiser: 'lemuhnltd3285add3dcc34e4d9a4194b3b2287fb0'
          });
          w.podscribe('purchase', {
            value: [PURCHASE_AMOUNT],
            order_number: [ORDER_ID],
            discount_code: [DISCOUNT_CODE],
            hashed_email: [HASHED_EMAIL],
          });
        })
      })(window, document);
